module.exports = __webpack_public_path__ + "static/lula-c58a888bd414233845d77f9146f1f66f.jpg";